import { useRef } from 'react';
import cn from 'classnames';

import useOutsideClick from 'js/hooks/use-outside-click';

import Message from 'components/message/Message';
import Button from 'components/button/Button';

import { IMessageGlobal } from 'source/NFR.types';

interface MessageGlobalModalProps extends IMessageGlobal {
  hideModal: () => void;
  ariaLabel?: string;
}

const MessageGlobalModal: React.FC<MessageGlobalModalProps> = ({ message, hideModal, ariaLabel, id, theme }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useOutsideClick(modalRef, hideModal);

  return (
    <div id={id} className={cn('message-global-modal')} ref={modalRef}>
      <Button className="message-global-modal--button" onClick={hideModal} icon="x" aria-label={ariaLabel} />
      <Message className="message-global-modal--message" text={message} theme={theme} />
    </div>
  );
};

MessageGlobalModal.displayName = 'MessageGlobalModal';

export default MessageGlobalModal;
